import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timespanFormat'
})
export class TimespanFormatPipe implements PipeTransform {

  transform(value: number): string { // timespan in seconds
    let hours = value / 3600;
    let days = Math.floor(hours / 24);
    hours = Math.round(hours - days * 24);

    return days.toString() + "d; " + hours.toString() + "h";
  }

}